import { loadable } from 'utils';

export const BasicInvoice = loadable(() => import('./BasicInvoice'), {});
export const Tracking = loadable(() => import('./Tracking'), {});
export const CustomerCancellation = loadable(() => import('./CustomerCancellation'), {});

export * as Cancel from './Cancel';
